import { render, staticRenderFns } from "./DataTable.component.vue?vue&type=template&id=99cc2b24"
import script from "./DataTable.component.ts?vue&type=script&lang=js&external"
export * from "./DataTable.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports